import React from 'react';
import CompletedRecalibrationsTable from '../../components/UI/CompletedRecalibrationsTable';
import { Main, Title, Icon, TableContainer } from '../../styles/tablePages';

interface Props {
  country: string;
}

const CompletedRecalibrations: React.FC<Props> = ({ country }) => {
  const title = 'Completed Recalibrations';

  return (
    <Main>
      <Title>
        <Icon />
        <h1>{title}</h1>
      </Title>

      <TableContainer>
        <CompletedRecalibrationsTable title={title} />
      </TableContainer>
    </Main>
  );
};

export default CompletedRecalibrations;
